export const spectrumColors = 
[
    {r: 131, g: 0, b: 181},
    {r: 131, g: 0, b: 185},
    {r: 131, g: 0, b: 188},
    {r: 131, g: 0, b: 192},
    {r: 130, g: 0, b: 196},
    {r: 130, g: 0, b: 200},
    {r: 129, g: 0, b: 204},
    {r: 129, g: 0, b: 207},
    {r: 128, g: 0, b: 211},
    {r: 127, g: 0, b: 215},
    {r: 126, g: 0, b: 219},
    {r: 124, g: 0, b: 222},
    {r: 123, g: 0, b: 226},
    {r: 121, g: 0, b: 230},
    {r: 120, g: 0, b: 233},
    {r: 118, g: 0, b: 237},
    {r: 116, g: 0, b: 241},
    {r: 113, g: 0, b: 244},
    {r: 111, g: 0, b: 248},
    {r: 109, g: 0, b: 251},
    {r: 106, g: 0, b: 255},
    {r: 102, g: 0, b: 255},
    {r: 97, g: 0, b: 255},
    {r: 93, g: 0, b: 255},
    {r: 89, g: 0, b: 255},
    {r: 84, g: 0, b: 255},
    {r: 80, g: 0, b: 255},
    {r: 75, g: 0, b: 255},
    {r: 70, g: 0, b: 255},
    {r: 66, g: 0, b: 255},
    {r: 61, g: 0, b: 255},
    {r: 56, g: 0, b: 255},
    {r: 51, g: 0, b: 255},
    {r: 46, g: 0, b: 255},
    {r: 40, g: 0, b: 255},
    {r: 35, g: 0, b: 255},
    {r: 29, g: 0, b: 255},
    {r: 23, g: 0, b: 255},
    {r: 17, g: 0, b: 255},
    {r: 10, g: 0, b: 255},
    {r: 0, g: 0, b: 255},
    {r: 0, g: 11, b: 255},
    {r: 0, g: 19, b: 255},
    {r: 0, g: 27, b: 255},
    {r: 0, g: 34, b: 255},
    {r: 0, g: 40, b: 255},
    {r: 0, g: 47, b: 255},
    {r: 0, g: 53, b: 255},
    {r: 0, g: 59, b: 255},
    {r: 0, g: 65, b: 255},
    {r: 0, g: 70, b: 255},
    {r: 0, g: 76, b: 255},
    {r: 0, g: 81, b: 255},
    {r: 0, g: 87, b: 255},
    {r: 0, g: 92, b: 255},
    {r: 0, g: 97, b: 255},
    {r: 0, g: 102, b: 255},
    {r: 0, g: 108, b: 255},
    {r: 0, g: 113, b: 255},
    {r: 0, g: 118, b: 255},
    {r: 0, g: 123, b: 255},
    {r: 0, g: 127, b: 255},
    {r: 0, g: 132, b: 255},
    {r: 0, g: 137, b: 255},
    {r: 0, g: 142, b: 255},
    {r: 0, g: 146, b: 255},
    {r: 0, g: 151, b: 255},
    {r: 0, g: 156, b: 255},
    {r: 0, g: 160, b: 255},
    {r: 0, g: 165, b: 255},
    {r: 0, g: 169, b: 255},
    {r: 0, g: 174, b: 255},
    {r: 0, g: 178, b: 255},
    {r: 0, g: 183, b: 255},
    {r: 0, g: 187, b: 255},
    {r: 0, g: 192, b: 255},
    {r: 0, g: 196, b: 255},
    {r: 0, g: 200, b: 255},
    {r: 0, g: 205, b: 255},
    {r: 0, g: 209, b: 255},
    {r: 0, g: 213, b: 255},
    {r: 0, g: 218, b: 255},
    {r: 0, g: 222, b: 255},
    {r: 0, g: 226, b: 255},
    {r: 0, g: 230, b: 255},
    {r: 0, g: 234, b: 255},
    {r: 0, g: 239, b: 255},
    {r: 0, g: 243, b: 255},
    {r: 0, g: 247, b: 255},
    {r: 0, g: 251, b: 255},
    {r: 0, g: 255, b: 255},
    {r: 0, g: 255, b: 245},
    {r: 0, g: 255, b: 234},
    {r: 0, g: 255, b: 224},
    {r: 0, g: 255, b: 213},
    {r: 0, g: 255, b: 203},
    {r: 0, g: 255, b: 192},
    {r: 0, g: 255, b: 181},
    {r: 0, g: 255, b: 169},
    {r: 0, g: 255, b: 158},
    {r: 0, g: 255, b: 146},
    {r: 0, g: 255, b: 135},
    {r: 0, g: 255, b: 123},
    {r: 0, g: 255, b: 110},
    {r: 0, g: 255, b: 97},
    {r: 0, g: 255, b: 84},
    {r: 0, g: 255, b: 70},
    {r: 0, g: 255, b: 56},
    {r: 0, g: 255, b: 40},
    {r: 0, g: 255, b: 23},
    {r: 0, g: 255, b: 0},
    {r: 9, g: 255, b: 0},
    {r: 15, g: 255, b: 0},
    {r: 21, g: 255, b: 0},
    {r: 26, g: 255, b: 0},
    {r: 31, g: 255, b: 0},
    {r: 36, g: 255, b: 0},
    {r: 40, g: 255, b: 0},
    {r: 45, g: 255, b: 0},
    {r: 49, g: 255, b: 0},
    {r: 54, g: 255, b: 0},
    {r: 58, g: 255, b: 0},
    {r: 62, g: 255, b: 0},
    {r: 66, g: 255, b: 0},
    {r: 70, g: 255, b: 0},
    {r: 74, g: 255, b: 0},
    {r: 78, g: 255, b: 0},
    {r: 82, g: 255, b: 0},
    {r: 86, g: 255, b: 0},
    {r: 90, g: 255, b: 0},
    {r: 94, g: 255, b: 0},
    {r: 97, g: 255, b: 0},
    {r: 101, g: 255, b: 0},
    {r: 105, g: 255, b: 0},
    {r: 108, g: 255, b: 0},
    {r: 112, g: 255, b: 0},
    {r: 115, g: 255, b: 0},
    {r: 119, g: 255, b: 0},
    {r: 123, g: 255, b: 0},
    {r: 126, g: 255, b: 0},
    {r: 129, g: 255, b: 0},
    {r: 133, g: 255, b: 0},
    {r: 136, g: 255, b: 0},
    {r: 140, g: 255, b: 0},
    {r: 143, g: 255, b: 0},
    {r: 146, g: 255, b: 0},
    {r: 150, g: 255, b: 0},
    {r: 153, g: 255, b: 0},
    {r: 156, g: 255, b: 0},
    {r: 160, g: 255, b: 0},
    {r: 163, g: 255, b: 0},
    {r: 166, g: 255, b: 0},
    {r: 169, g: 255, b: 0},
    {r: 173, g: 255, b: 0},
    {r: 176, g: 255, b: 0},
    {r: 179, g: 255, b: 0},
    {r: 182, g: 255, b: 0},
    {r: 185, g: 255, b: 0},
    {r: 189, g: 255, b: 0},
    {r: 192, g: 255, b: 0},
    {r: 195, g: 255, b: 0},
    {r: 198, g: 255, b: 0},
    {r: 201, g: 255, b: 0},
    {r: 204, g: 255, b: 0},
    {r: 207, g: 255, b: 0},
    {r: 210, g: 255, b: 0},
    {r: 213, g: 255, b: 0},
    {r: 216, g: 255, b: 0},
    {r: 219, g: 255, b: 0},
    {r: 222, g: 255, b: 0},
    {r: 225, g: 255, b: 0},
    {r: 228, g: 255, b: 0},
    {r: 231, g: 255, b: 0},
    {r: 234, g: 255, b: 0},
    {r: 237, g: 255, b: 0},
    {r: 240, g: 255, b: 0},
    {r: 243, g: 255, b: 0},
    {r: 246, g: 255, b: 0},
    {r: 249, g: 255, b: 0},
    {r: 252, g: 255, b: 0},
    {r: 255, g: 255, b: 0},
    {r: 255, g: 252, b: 0},
    {r: 255, g: 249, b: 0},
    {r: 255, g: 246, b: 0},
    {r: 255, g: 242, b: 0},
    {r: 255, g: 239, b: 0},
    {r: 255, g: 236, b: 0},
    {r: 255, g: 233, b: 0},
    {r: 255, g: 230, b: 0},
    {r: 255, g: 226, b: 0},
    {r: 255, g: 223, b: 0},
    {r: 255, g: 220, b: 0},
    {r: 255, g: 217, b: 0},
    {r: 255, g: 213, b: 0},
    {r: 255, g: 210, b: 0},
    {r: 255, g: 207, b: 0},
    {r: 255, g: 203, b: 0},
    {r: 255, g: 200, b: 0},
    {r: 255, g: 197, b: 0},
    {r: 255, g: 193, b: 0},
    {r: 255, g: 190, b: 0},
    {r: 255, g: 187, b: 0},
    {r: 255, g: 183, b: 0},
    {r: 255, g: 180, b: 0},
    {r: 255, g: 176, b: 0},
    {r: 255, g: 173, b: 0},
    {r: 255, g: 169, b: 0},
    {r: 255, g: 166, b: 0},
    {r: 255, g: 162, b: 0},
    {r: 255, g: 159, b: 0},
    {r: 255, g: 155, b: 0},
    {r: 255, g: 152, b: 0},
    {r: 255, g: 148, b: 0},
    {r: 255, g: 145, b: 0},
    {r: 255, g: 141, b: 0},
    {r: 255, g: 137, b: 0},
    {r: 255, g: 134, b: 0},
    {r: 255, g: 130, b: 0},
    {r: 255, g: 126, b: 0},
    {r: 255, g: 123, b: 0},
    {r: 255, g: 119, b: 0},
    {r: 255, g: 115, b: 0},
    {r: 255, g: 111, b: 0},
    {r: 255, g: 107, b: 0},
    {r: 255, g: 103, b: 0},
    {r: 255, g: 99, b: 0},
    {r: 255, g: 95, b: 0},
    {r: 255, g: 91, b: 0},
    {r: 255, g: 87, b: 0},
    {r: 255, g: 83, b: 0},
    {r: 255, g: 79, b: 0},
    {r: 255, g: 75, b: 0},
    {r: 255, g: 70, b: 0},
    {r: 255, g: 66, b: 0},
    {r: 255, g: 62, b: 0},
    {r: 255, g: 57, b: 0},
    {r: 255, g: 52, b: 0},
    {r: 255, g: 48, b: 0},
    {r: 255, g: 43, b: 0},
    {r: 255, g: 38, b: 0},
    {r: 255, g: 33, b: 0},
    {r: 255, g: 27, b: 0},
    {r: 255, g: 22, b: 0},
    {r: 255, g: 16, b: 0},
    {r: 255, g: 9, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 255, g: 0, b: 0},
    {r: 253, g: 0, b: 0},
    {r: 251, g: 0, b: 0},
    {r: 250, g: 0, b: 0},
    {r: 248, g: 0, b: 0},
    {r: 246, g: 0, b: 0},
    {r: 244, g: 0, b: 0},
    {r: 242, g: 0, b: 0},
    {r: 241, g: 0, b: 0},
    {r: 239, g: 0, b: 0},
    {r: 237, g: 0, b: 0},
    {r: 235, g: 0, b: 0},
    {r: 233, g: 0, b: 0},
    {r: 232, g: 0, b: 0},
    {r: 230, g: 0, b: 0},
    {r: 228, g: 0, b: 0},
    {r: 226, g: 0, b: 0},
    {r: 224, g: 0, b: 0},
    {r: 222, g: 0, b: 0},
    {r: 220, g: 0, b: 0},
    {r: 219, g: 0, b: 0},
    {r: 217, g: 0, b: 0},
    {r: 215, g: 0, b: 0},
    {r: 213, g: 0, b: 0},
    {r: 211, g: 0, b: 0},
    {r: 209, g: 0, b: 0},
    {r: 207, g: 0, b: 0},
    {r: 206, g: 0, b: 0},
    {r: 204, g: 0, b: 0},
    {r: 202, g: 0, b: 0},
    {r: 200, g: 0, b: 0},
    {r: 198, g: 0, b: 0},
    {r: 196, g: 0, b: 0},
    {r: 194, g: 0, b: 0},
    {r: 192, g: 0, b: 0},
    {r: 190, g: 0, b: 0},
    {r: 188, g: 0, b: 0},
    {r: 186, g: 0, b: 0},
    {r: 185, g: 0, b: 0},
    {r: 183, g: 0, b: 0},
    {r: 181, g: 0, b: 0},
    {r: 179, g: 0, b: 0},
    {r: 177, g: 0, b: 0},
    {r: 175, g: 0, b: 0},
    {r: 173, g: 0, b: 0},
    {r: 171, g: 0, b: 0},
    {r: 169, g: 0, b: 0},
    {r: 167, g: 0, b: 0},
    {r: 165, g: 0, b: 0},
    {r: 163, g: 0, b: 0},
    {r: 161, g: 0, b: 0}
];


export default spectrumColors;